<template>
  <div id="app">
    <h1>{{ message }}</h1>
    <hr>
    <element-view></element-view>
  </div>
</template>
<script>
import ElementView from './views/element/ElementView.vue'
export default {
  components: { ElementView },
  data () {
    return {
      message:"Hello Vue 赵辰浩！"
    }
  }
}
</script>
<style>
h1 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #b94256;;
}
</style>